import React from 'react';
import {Params} from './../params.jsx'
import SecondHead from './../components/SecondHead'
import bonichi from './../assets/images/IMG_bonichi_2.jpeg'



function ConfirmationProblem(props){
    const lang = props.lang

    return(

        <>
        <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container mymarge">
            <div className="row bg2">
                <div className="col d-flex justify-content-center mt-3">
                   <div className="fs-3">
                        <p>{Params(props.lang).brand}</p>
                    </div>
                </div>
            </div>
   
            <div className="row bg2">
                <div className="col text-center pt-3 pb-3">
                    <div>
                       <img src={bonichi} className="img-fluid" alt="confirmation"/>
                    </div>
                </div>
            </div>

            <div className="row bg7">
                <div className="col text-center pt-3 pb-3">
                    <div>
                      <p>{Params(lang).error_2}</p>
                    
                    </div>
                </div>
            </div>
            <div className="row mb-3 bg7">
                <div className="col-md-4 offset-md-4 text-center pt-3 pb-3">   
                </div>
            </div>
        </div>
    
        </>
        )

}

export default ConfirmationProblem;